/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class YesNo.
* @enum {}
* @readonly
*/
export default class YesNo {
    
        /**
         * value: "YES"
         * @const
         */
        "YES" = "YES";

    
        /**
         * value: "NO"
         * @const
         */
        "NO" = "NO";

    

    /**
    * Returns a <code>YesNo</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/YesNo} The enum <code>YesNo</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

